import { configurePlatform, type PlatformAdapter } from "@zatio/shared";

const webAdapter: PlatformAdapter = {
  getToken() {
    return localStorage.getItem("sessionToken");
  },
  setToken(token: string) {
    localStorage.setItem("sessionToken", token);
  },
  clearToken() {
    localStorage.removeItem("sessionToken");
  },
  getBaseUrl() {
    return new URL("/api", window.location.origin).toString();
  },
  onForceLogout() {
    window.dispatchEvent(new CustomEvent("auth:logout"));
  },
};

configurePlatform(webAdapter);
